export default __webpack_public_path__ + "src/assets/ens.d7783f65ff85576c9cc96006a50a6df2.svg";